
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const fontreferenceApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listFontReferences: builder.query ({
      query: (params) => `v2/fontreference/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["FontReference"]
    }),
    getFontReference: builder.query ({
      query: (fontreference_id) => `v2/fontreference/${fontreference_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["FontReference"]
    }),

    updateFontReference: builder.mutation ({
      query: ({fontreference_id, data}) => ({
        url: `v2/fontreference/${fontreference_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["FontReference"]
    }),
    deleteFontReference: builder.mutation ({
      query: (fontreference_id) => ({
        url: `v2/fontreference/${fontreference_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["FontReference"]
    }),
    createFontReference: builder.mutation ({
      query: (data) => ({
        url: `v2/fontreference/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["FontReference"]
    }),
  })
})


export const {
  useListFontReferencesQuery,
  useLazyListFontReferencesQuery,
  useGetFontReferenceQuery,
  useLazyGetFontReferenceQuery,

  useUpdateFontReferenceMutation,
  useDeleteFontReferenceMutation,
  useCreateFontReferenceMutation
} = fontreferenceApi
